<div class="chat-header">
  <div class="channel-list">
    <cs-select
      [disabled]="isLoading()"
      [(value)]="currentChannelUrl"
      [options]="channelList()"
      [width]="'133px'"
      (valueChange)="selectChannel(currentChannelUrl)"
    ></cs-select>
  </div>
  <div class="chat-info">
    <!-- <div class="chat-online">
      <i></i>
      <span class="online-num">{{ totalMemberCount() }}</span>
    </div> -->
    <div class="chat-rule" (click)="handleOpenChatRule()">Chat rules</div>
    <i class="fi-x" (click)="sendbirdChatService.hideChat()"></i>
  </div>
</div>
